export default __webpack_public_path__ + "static/media/Group 12891.c4cc6ec6.svg";